import { render, staticRenderFns } from "./ContactEditor.vue?vue&type=template&id=35162466&scoped=true&"
import script from "./ContactEditor.vue?vue&type=script&lang=js&"
export * from "./ContactEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35162466",
  null
  
)

export default component.exports